import Schedule from './CutileiSchedule'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ReactComponent as Loading } from 'icons/loading2.svg'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function CutileiScheduleList ({
  schedules = [],
  totalSchedules,
  scheduleStatuses = [],
  hasMore,
  endMessage,
  // O id do elemento que rola (o corpo do Dialog); sem ele, a lista ouve a janela
  scrollableTarget,
  onScroll: handleScroll,
  onScheduleSelected: handleScheduleSelected = () => null
}) {
  return (
    <Container>
      {!!totalSchedules && totalSchedules > 0 && (
        <SubTitle>
          {totalSchedules + ' ' + (totalSchedules === 1 ? 'Resultado' : 'Resultados')}
        </SubTitle>
      )}
      {schedules.length > 0 ? (
        <>
          <LabelRow>
            <SubTitle>Membro</SubTitle>
            <SubTitle>Salão</SubTitle>
            <SubTitle>Serviço</SubTitle>
            <SubTitle>Profissional</SubTitle>
            <SubTitle>Data</SubTitle>
            <SubTitle>Horário</SubTitle>
            <SubTitle style={{justifySelf: 'center'}}>Preço</SubTitle>
          </LabelRow>
          <InfiniteScroll
            dataLength={schedules.length}
            next={handleScroll}
            hasMore={hasMore}
            loader={<Loading/>}
            endMessage={endMessage}
            scrollableTarget={scrollableTarget}
            style={{ overflow: 'visible', paddingBottom: 10 }}
          >
            {schedules.map (schedule => (
              <Schedule
                key={schedule.id}
                data={schedule}
                scheduleStatuses={scheduleStatuses}
                onClick={handleScheduleSelected}
              />
            ))}
          </InfiniteScroll>
        </>
      ) : (
        <InfoText>Nenhum agendamento encontrado</InfoText>
      )}
    </Container>
  )
}
